import { useAuth } from "react-oidc-context";

import { AuthState } from "../../types/auth.types";
import { ProfileIconProps } from "../../types/components.types";

const ProfileIcon: React.FC<ProfileIconProps> = () => {
  // Access the current authentication state.
  const auth = useAuth() as AuthState;

  // Extract the user's first name from the given_name attribute in the user's profile from AWS Cognito.
  // If the attribute is missing, default to an empty string.
  const firstName = auth.user?.profile.given_name ?? "";
  // Extract the user's last name from the family_name attribute in the user's profile from AWS Cognito.
  // If the attribute is missing, default to an empty string.
  const lastName = auth.user?.profile.family_name ?? "";

  const photoUrl = auth.user?.profile.picture;

  // Generate and return user initials.
  const getInitials = (): string => {
    // If both first and last names are empty, return an empty string.
    if (!firstName && !lastName) return "";

    // Extract the first character from the first name and capatilise it.
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
    // Extract the first character from the last name and capatilise it.
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
    // Return the combined initials.
    return `${firstInitial}${lastInitial}`;
  };

  // Combine the first and last name.
  // Remove any empty strings using the .filter(Boolean) before joining.
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    // The `title` attribute provides the full name as a tooltip on hover.
    <div className="profile-section">
      <span className="profile-section__username">{fullName}</span>
      <div className="profile-icon" title={fullName}>
        {photoUrl ? (
          <img src={photoUrl} alt="Profile" className="profile-icon__image" />
        ) : (
          <span className="profile-icon__initials">{getInitials()}</span>
        )}
      </div>
    </div>
  );
};

export default ProfileIcon;
